
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  name: 'Alert',
})
class Alert extends Vue {
  visible:boolean = false;
  title:string = '';
  text:string = '';
  alertText:string='';
  @Prop({ default: () => {} }) confirm:Function|undefined;
  @Prop({ default: () => {} }) cancel:Function|undefined;
  get isMobile() {
    return !this.$platform.pc;
  };
}
export default Alert;
